import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import { FormattedMessage } from 'react-intl';
import { getImageUrl, Languages, getCurrentLang } from '~/common';

const API_TIME_FORMAT = 'YYYYMMDDHHmmss';
const UI_DATE_TIME_FORMAT = getCurrentLang() === Languages.en_us ? 'DD MMM YYYY (ddd) h:mm a' : 'YYYY年MM月DD日 (ddd) h:mm a';

class CarDetail extends Component {
    constructor(props) {
        super(props);
        this.state = {};
    }

    componentDidMount() {

    }

    render() {
        const { detail } = this.props;
        if (!detail) return null;
        const places = [...new Set([detail.PickUpLocationCode, detail.DropOffLocationCode])];
        return (
            <div className='detail-car-item'>
                <div className='routing-brief'>
                    {places.join('-')}
                </div>
                <div className='routing-detail'>
                    <div className='routing-detail-title'>
                        <div className='left-col'>
                            <div className='car-number-font'>{`${detail.VendorName}`}</div>
                        </div>
                    </div>
                    <div>
                        <div className='car-item'>
                            <div className='car-item-info'>
                                <div className='date-car-info'>
                                    <div>{moment(detail.PickUpDateTimeRemark, API_TIME_FORMAT).format(UI_DATE_TIME_FORMAT).toUpperCase()}</div>
                                    <div>{`${detail.PickUploactionName || detail.PickUpLocationCode} (${detail.PickUpLocationCode})`}</div>
                                </div>
                                <div className='elapsed-time-info'>
                                    
                                </div>
                                <div className='date-car-info'>
                                    <div>{moment(detail.DropOffDateTimeRemark, API_TIME_FORMAT).format(UI_DATE_TIME_FORMAT).toUpperCase()}</div>
                                    <div>{`${detail.DropOffLocationName || detail.DropOffLocationCode} (${detail.DropOffLocationCode})`}</div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

CarDetail.propTypes = {
    detail: PropTypes.object.isRequired,
}

export default CarDetail;